enum FlashcardRunMode {
    EXTENSIVE = 'EXTENSIVE',
    INTENSIVE = 'INTENSIVE',
}

export default FlashcardRunMode;
